import { render, staticRenderFns } from "./communication-logs-listing.vue?vue&type=template&id=221442e0&scoped=true&"
import script from "./communication-logs-listing.vue?vue&type=script&lang=js&"
export * from "./communication-logs-listing.vue?vue&type=script&lang=js&"
import style0 from "./communication-logs-listing.vue?vue&type=style&index=0&id=221442e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221442e0",
  null
  
)

export default component.exports